/*
  HELIFOUNDRY enhancements — loaded after Dawn's constants.js / pubsub.js / global.js.
  1. Mobile gallery dot indicator (replaces the numeric slider counter)
  2. Variant picker image pills (adds each bird's photo to Dawn's pill labels)
  3. Variant change -> gallery jumps to the matching model photo (alt-text match)
  4. Mobile sticky add-to-cart bar
  Everything feature-detects and fails silently so Dawn keeps working untouched.
  Re-initializes on shopify:section:load so the theme editor keeps the enhancements.
*/
(function () {
  'use strict';

  // Dawn declares subscribe/PUB_SUB_EVENTS with function/const in classic
  // scripts — const bindings never land on window, so probe the bare names.
  var canSubscribe = false;
  var subscribeFn = null;
  var events = null;
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribeFn = subscribe;
      events = PUB_SUB_EVENTS;
      canSubscribe = true;
    }
  } catch (e) {
    canSubscribe = false;
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function getProductData() {
    var el = document.getElementById('HfProductData');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalize(str) {
    return (str || '').toLowerCase().replace(/\s+kit\s*$/, '').trim();
  }

  /* ---------- 1. Gallery dots ---------- */
  function initGalleryDots() {
    var gallery = document.querySelector('.product__media-wrapper media-gallery');
    if (!gallery) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || viewer.querySelector('.hf-gallery-dots')) return;
    var slides = viewer.querySelectorAll('.product__media-item');
    if (slides.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'hf-gallery-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('span');
      dot.className = 'hf-gallery-dots__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(dot);
    }
    viewer.appendChild(dots);

    viewer.addEventListener('slideChanged', function (event) {
      var page = event.detail && event.detail.currentPage ? event.detail.currentPage : 1;
      var children = dots.children;
      for (var j = 0; j < children.length; j++) {
        children[j].classList.toggle('is-active', j === page - 1);
      }
    });
  }

  /* ---------- 2. Variant image pills ---------- */
  function decoratePills(data) {
    var pickers = document.querySelectorAll('variant-selects');
    pickers.forEach(function (picker) {
      var fieldsets = picker.querySelectorAll('.product-form__input--pill');
      fieldsets.forEach(function (fieldset) {
        var inputs = fieldset.querySelectorAll('input[type="radio"]');
        if (!inputs.length) return;
        var matched = 0;
        inputs.forEach(function (input) {
          var label = fieldset.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
          if (!label) return;
          if (label.querySelector('.hf-pill-img')) {
            matched++;
            return;
          }
          var value = normalize(input.value);
          var variant = data.variants.find(function (v) {
            return normalize(v.title) === value || normalize(v.option1) === value;
          });
          if (!variant || !variant.image) return;
          var wrap = document.createElement('span');
          wrap.className = 'hf-pill-img';
          var img = document.createElement('img');
          img.src = variant.image + (variant.image.indexOf('?') > -1 ? '&' : '?') + 'width=180';
          img.alt = '';
          img.loading = 'lazy';
          img.width = 90;
          img.height = 90;
          wrap.appendChild(img);
          label.insertBefore(wrap, label.firstChild);
          matched++;
        });
        if (matched > 0) picker.classList.add('hf-variant-images');
      });
    });
  }

  var pillsObserver = null;
  function initVariantPills() {
    var data = getProductData();
    if (!data || !data.variants || !data.variants.length) return;

    decoratePills(data);

    // Dawn re-renders (and can fully replace) the variant-selects element after
    // a selection change, so watch a stable ancestor and re-decorate.
    var container = document.querySelector('product-info') || document.querySelector('.product__info-container') || document.body;
    if ('MutationObserver' in window) {
      if (pillsObserver) pillsObserver.disconnect();
      var scheduled = false;
      pillsObserver = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        setTimeout(function () {
          scheduled = false;
          decoratePills(data);
        }, 50);
      });
      pillsObserver.observe(container, { childList: true, subtree: true });
    }
  }

  /* ---------- 3. Variant -> gallery sync ---------- */
  var gallerySyncUnsub = null;
  function initGallerySync() {
    if (!canSubscribe) return;
    var gallery = document.querySelector('.product__media-wrapper media-gallery');
    if (!gallery) return;

    if (gallerySyncUnsub) gallerySyncUnsub();
    gallerySyncUnsub = subscribeFn(events.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant || variant.featured_media) return; // Dawn handles featured media itself
      var needle = normalize(variant.title);
      if (!needle) return;
      var slides = gallery.querySelectorAll('.product__media-item');
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        var alt = img ? (img.getAttribute('alt') || '').toLowerCase() : '';
        if (alt && alt.indexOf(needle) > -1) {
          if (typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(slides[i].getAttribute('data-media-id'), false);
          } else {
            slides[i].parentElement.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          }
          break;
        }
      }
    });
  }

  /* ---------- 4. Sticky add-to-cart ---------- */
  var stickyCleanup = null;
  var stickySyncUnsub = null;
  function initStickyAtc() {
    var bar = document.getElementById('HfStickyAtc');
    if (!bar) return;
    var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    var mainButton = mainForm ? mainForm.querySelector('button[type="submit"][name="add"]') : null;
    if (!mainButton) return;

    var stickyButton = bar.querySelector('.hf-sticky-atc__button');
    var stickyPrice = bar.querySelector('.hf-sticky-atc__price');
    var stickyThumb = bar.querySelector('.hf-sticky-atc__thumb');
    var data = getProductData();

    // Scroll-driven check (an IntersectionObserver misses fast momentum
    // scrolls and programmatic jumps where the button never paints in-viewport).
    function updateBarVisibility() {
      var past = mainButton.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('hf-sticky-atc-visible', past);
    }
    if (stickyCleanup) stickyCleanup();
    window.addEventListener('scroll', updateBarVisibility, { passive: true });
    window.addEventListener('resize', updateBarVisibility, { passive: true });
    stickyCleanup = function () {
      window.removeEventListener('scroll', updateBarVisibility);
      window.removeEventListener('resize', updateBarVisibility);
    };
    updateBarVisibility();

    stickyButton.addEventListener('click', function () {
      if (mainButton.getAttribute('aria-disabled') === 'true' || mainButton.disabled) return;
      mainButton.click();
    });

    function syncFromVariant(variant) {
      if (!variant) {
        stickyButton.disabled = true;
        stickyButton.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'Unavailable';
        return;
      }
      var soldOut = !variant.available;
      stickyButton.disabled = soldOut;
      stickyButton.textContent = soldOut
        ? (window.variantStrings && window.variantStrings.soldOut) || 'Sold out'
        : (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      if (data && data.variants) {
        var match = data.variants.find(function (v) {
          return String(v.id) === String(variant.id);
        });
        if (match) {
          if (match.priceFormatted && stickyPrice) stickyPrice.textContent = match.priceFormatted;
          if (match.image && stickyThumb) {
            // The Liquid-rendered img carries srcset, which outranks src in every
            // browser — clear it so the variant image swap actually displays.
            stickyThumb.removeAttribute('srcset');
            stickyThumb.removeAttribute('sizes');
            stickyThumb.src = match.image + (match.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          }
        }
      }
    }

    if (canSubscribe) {
      if (stickySyncUnsub) stickySyncUnsub();
      stickySyncUnsub = subscribeFn(events.variantChange, function (event) {
        syncFromVariant(event && event.data ? event.data.variant : null);
      });
    }
  }

  function initAll() {
    initGalleryDots();
    initVariantPills();
    initGallerySync();
    initStickyAtc();
  }

  ready(initAll);

  // Theme editor re-renders sections; re-attach the enhancements.
  document.addEventListener('shopify:section:load', function () {
    initAll();
  });
})();


/* ---------- 5. Gallery prev/next arrows ----------
   Markup lives in product-media-gallery.liquid (.hf-gallery-arrow buttons).
   Desktop (min-width 750px, thumbnail layouts): drive media-gallery's
   setActiveMedia — identical to a thumbnail click (see media-gallery.js).
   Mobile: the media list is a native Dawn slider; scroll it directly the same
   way media-gallery.js does (scrollTo offsetLeft), which fires slideChanged
   so the dot indicator and Dawn's counter stay in sync. Wraps at both ends. */
(function () {
  'use strict';

  var desktopMql = window.matchMedia('(min-width: 750px)'); // same query as media-gallery.js

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('.hf-gallery-arrow');
    if (!button) return;

    var gallery = button.closest('media-gallery');
    var viewer = button.closest('[id^="GalleryViewer"]');
    if (!gallery || !viewer) return;

    var direction = button.classList.contains('hf-gallery-arrow--next') ? 1 : -1;
    var slides = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    if (desktopMql.matches) {
      // Desktop: same code path as clicking the next/previous thumbnail.
      var current = 0;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) {
          current = i;
          break;
        }
      }
      var target = (current + direction + slides.length) % slides.length;
      var mediaId = slides[target].getAttribute('data-media-id');
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        // Element not upgraded yet: fall back to a real thumbnail click.
        var thumb = gallery.querySelector('[id^="GalleryThumbnails"] [data-target="' + mediaId + '"] button');
        if (thumb) thumb.click();
      }
    } else {
      // Mobile: scroll the slider ul; Dawn's scroll listener emits slideChanged.
      var slider = viewer.querySelector('[id^="Slider-Gallery"]');
      if (!slider) return;
      var stride = slides[1].offsetLeft - slides[0].offsetLeft;
      if (stride <= 0) stride = slides[0].clientWidth || 1;
      var index = Math.round(slider.scrollLeft / stride);
      var next = (index + direction + slides.length) % slides.length;
      // No behavior override: the .slider CSS scroll-behavior (and the user's
      // reduced-motion preference) decides smoothness, same as media-gallery.js.
      slider.scrollTo({ left: slides[next].offsetLeft });
    }
  });
})();
